import React from 'react'
import { useIsMobile } from '../../hooks/useIsMobile';

const ErrorComunicacion = () => {

  const isMobile = useIsMobile(600);
    return (
        <div>
          {isMobile ? 
            (<div className='info-container-img'>
                  <img src='Images/logo-azul.png' alt='Logo Medicus 50' />
            </div>) :
            (<div className='info-container-img'>
                  {/* <img src='Images/headerResponsive.png' alt='Logo Medicus 50'></img> */}
            </div>)
          }
          <div className="info-container-vencido">
            <h3>
                <strong>
                {/* Hola, <br></br> */}
                Hubo un error al tratar de continuar, comunicarse con el administrador
                </strong>
            </h3>
          </div>
        </div>
      )
}

export default ErrorComunicacion